import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface DivisionListItem {
  divisionDesc: string;
  divisionKey: number;
}

export const getDivisionListAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetDivision`,
  });
};

export type DivisionListResponse = DivisionListItem[];

export const fetchDivisionList = async (): Promise<DivisionListResponse> => {
  const response: AxiosResponse<DivisionListResponse> = await getDivisionListAPI();
  return response.data;
};
